import { token } from '@atlaskit/tokens';
import { type RequestedResponder } from '@atlassian/eoc-schedule-common';

// this is used to calculate indicators height
const LAYER_HEIGHT = token('space.200', '16px');

const SCHEDULE_NAME_MAX_LENGTH = 127;
// TODO: LEARN CORRECT MAX LENGTH
const ROTATION_NAME_MAX_LENGTH = 127;

const WEEK_DAY_COUNT = 7;

const REQUESTED_NO_ONE: RequestedResponder = {
	id: 'noone',
	type: 'noone',
} as const;

/*
 * Times - ["00:00", "00:30", ..., "23:00", "23:30"]
 */
const DEFAULT_TIMES = Array.from({ length: 24 }, (_, i) => i).flatMap((time) => {
	return [`${time}:00`, `${time}:30`].map((t) => t.padStart(5, '0'));
});

const SPOTLIGHT_NAMES = {
	firstSchedule: 'eoc-schedule_first_schedule',
	firstListRotationItem: 'eoc-schedule_first_list_schedule_item',
	firstScheduleActions: 'eoc-schedule-first-schedule_actions',
	editRotationTimings: 'eoc-schedule-edit_rotation_timings',
	editRotationForm: 'eoc-schedule_edit_rotation_rotation',
	editModeSchedule: 'eoc-schedule-edit_mode_schedule',
	shiftTile: 'eoc-schedule-shift_tile',
};

const SPOTLIGHT_TOURS = {
	rotationEdit: 'eoc-schedule-rotation-edit',
	shiftTile: 'eoc-schedule-shift-tile',
	rotationList: 'eoc-schedule-rotation-list',
	scheduleActions: 'eoc-schedule-schedule-actions',
};

const ANALYTICS_TAGS = {
	onCall: ['eoc-schedule', 'eoc-on-call'],
	editMode: ['eoc-on-call', 'eoc-schedule', 'eoc-edit-mode'],
	editRotation: ['eoc-on-call', 'eoc-schedule', 'eoc-edit-mode', 'eoc-edit-rotation'],
};

export {
	ANALYTICS_TAGS,
	DEFAULT_TIMES,
	LAYER_HEIGHT,
	REQUESTED_NO_ONE,
	ROTATION_NAME_MAX_LENGTH,
	SCHEDULE_NAME_MAX_LENGTH,
	SPOTLIGHT_NAMES,
	SPOTLIGHT_TOURS,
	WEEK_DAY_COUNT,
};
